import { LogtoProvider as LogtoSDKProvider, UserScope } from '@logto/react';
import type { ReactNode } from 'react';

const LOGTO_ENDPOINT = import.meta.env.VITE_LOGTO_ENDPOINT as string | undefined;
const LOGTO_APP_ID = import.meta.env.VITE_LOGTO_APP_ID as string | undefined;
const LOGTO_API_RESOURCE = import.meta.env.VITE_LOGTO_API_RESOURCE as string | undefined;

if (!LOGTO_ENDPOINT || !LOGTO_APP_ID) {
  console.warn(
    '[HelloAnt] VITE_LOGTO_ENDPOINT and VITE_LOGTO_APP_ID must be set. '
    + 'See .env.example.',
  );
}

export const LOGTO_RESOURCES = LOGTO_API_RESOURCE ? [LOGTO_API_RESOURCE] : [];

export function LogtoProvider({ children }: { children: ReactNode }) {
  return (
    <LogtoSDKProvider
      config={{
        endpoint: LOGTO_ENDPOINT ?? '',
        appId: LOGTO_APP_ID ?? '',
        resources: LOGTO_RESOURCES,
        scopes: [UserScope.Email, UserScope.Profile],
      }}
    >
      {children}
    </LogtoSDKProvider>
  );
}

export { LOGTO_API_RESOURCE };
